export const useNotificationStore = defineStore('notification', () => {
  const pushNotificationApi = usePushNotificationApi();
  const tokenStore = useTokenStore();

  const notifications = ref<NotificationOverviewResponseDTO[]>([]);
  const isFinalPage = ref(false);

  const allNotifications = computed(() => notifications.value);
  const unreadNotifications = computed(() => notifications.value.filter(n => n.ReadDate === null));
  const hasUnread = computed(() => unreadNotifications.value.length > 0);
  const unreadCount = computed(() => unreadNotifications.value.length);

  async function getPushNotifications(dto: GetUserNotificationsDTO) {
    try {
      const response = await pushNotificationApi.getNotificationsByUser(dto);

      if (response?.HasErrors === false) {
        notifications.value = response.Data.Notifications;
        isFinalPage.value = response.Data.IsFinalPage;

        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  }

  async function appendPushNotifications(dto: GetUserNotificationsDTO) {
    try {
      const response = await pushNotificationApi.getNotificationsByUser(dto);

      if (response?.HasErrors === false) {
        notifications.value = [...notifications.value, ...response.Data.Notifications];
        isFinalPage.value = response.Data.IsFinalPage;

        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  }

  async function markAsRead(notificationId: string) {
    const notification = notifications.value.find(n => n.NotificationID === notificationId);

    if (!notification || notification.ReadDate !== null) return;

    try {
      const userId = await tokenStore.getUserID();
      await pushNotificationApi.markNotificationAsRead({ NotificationIds: [notificationId], UserId: userId });
      notification.ReadDate = new Date().toISOString();
    } catch {
      // ignore
    }
  }

  async function markAllAsRead() {
    try {
      const userId = await tokenStore.getUserID();
      await pushNotificationApi.markAllNotificationsAsRead({ UserId: userId });

      const now = new Date().toISOString();

      for (const notification of notifications.value) {
        if (notification.ReadDate === null) {
          notification.ReadDate = now;
        }
      }
    } catch {
      // ignore
    }
  }

  return { notifications, allNotifications, unreadNotifications, hasUnread, unreadCount, isFinalPage, getPushNotifications, appendPushNotifications, markAsRead, markAllAsRead };
});
